import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import { MdError } from 'react-icons/md';

import {
  Container,
  ModalContainer,
  ModalHeader,
  ModalFooter,
  ButtonModal,
} from './styles';

const ModalPendenciaDeEnvio = ({
  modalPendenciaDeEnvio,
  setModalPendenciaDeEnvio,
  mesesPendentes,
}) => {
  const handleOk = () => {
    setModalPendenciaDeEnvio(false);
  };
  const handleCancel = () => {
    setModalPendenciaDeEnvio(false);
  };

  const exibirDepois = () => {
    sessionStorage.setItem('PendenciaDeEnvio', '1');
    setModalPendenciaDeEnvio(false);
  };

  return (
    <Container>
      <Modal
        visible={mesesPendentes?.length > 0 && modalPendenciaDeEnvio}
        onOk={handleOk}
        onCancel={handleCancel}
        cancelText="Conferir depois"
        centered
        footer={null}
        width="480px"
      >
        <ModalContainer>
          <ModalHeader>
            <div className="iconModal">
              <span>
                <MdError size={30} />
              </span>
            </div>
            <h2>
              Há <span> pendências de envio</span> para esta instituição.
            </h2>
          </ModalHeader>
          <div className="ModalBody">
            <div>
              <p>Confira os meses com pendência:</p>
            </div>

            <div>
              <p className="mesesPendentes">
                {String(mesesPendentes)
                  .split(',')
                  .join(', ')}
                .
              </p>
            </div>
          </div>
        </ModalContainer>

        <ModalFooter>
          <ButtonModal type="button" onClick={handleOk}>
            Ok! Obrigado!
          </ButtonModal>
          <ButtonModal type="button" cancel onClick={exibirDepois}>
            Não exibir novamente
          </ButtonModal>
        </ModalFooter>
      </Modal>
    </Container>
  );
};

ModalPendenciaDeEnvio.propTypes = {
  mesesPendentes: PropTypes.array,
  setModalPendenciaDeEnvio: PropTypes.func.isRequired,
  modalPendenciaDeEnvio: PropTypes.bool.isRequired,
};

ModalPendenciaDeEnvio.defaultProps = {
  mesesPendentes: [],
};

export default ModalPendenciaDeEnvio;
